import React from "react"
import { Helmet } from "react-helmet"
import { StaticQuery, graphql } from "gatsby"
import Footer from "../footer/footer"
import Header from "../header/header"
import layoutStyles from "../../styles/common/layout.module.scss"
// import ChatIcon from "../assets/whatsapp.svg"

/* if (typeof window !== "undefined") {
  require("smooth-scroll")('a[href*="#"]')
} */

const Layout = ({ pageMeta, children, location, cssClass }) => (
  <StaticQuery
    query={graphql`
      query LayoutQuery {
        site {
          siteMetadata {
            title
            menuLinks {
              name
              link
            }
          }
        }
      }
    `}
    render={(data) => (
      <>
        <Helmet>
          <meta charset="UTF-8" />
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0"
          />
          <html lang="it" />
          <title>{`${pageMeta.title} | ${data.site.siteMetadata.title}`}</title>
          <meta name="description" content={pageMeta.description} />
          <meta name="keywords" content={pageMeta.keywords.join(",")} />
          <link
            rel="canonical"
            href={`https://www.santuariodiboca.it${pageMeta.link}`}
          />
        </Helmet>
        <div className={layoutStyles.page}>
          <Header
            menuLinks={data.site.siteMetadata.menuLinks}
            siteTitle={data.site.siteMetadata.title}
            location={location}
          />
          <div className={cssClass}>{children}</div>
          <Footer />
        </div>
      </>
    )}
  />
)

export default Layout
